// extracted by mini-css-extract-plugin
export default {"container":"on-off_container__esrYo","sign":"on-off_sign__plTIq","off":"on-off_off__eFXz8","statement":"on-off_statement__PeuaF"};